import React from 'react';
import { SURFACE, SURFACE_RAISED } from '../../uiTokens';

/** Card surface. `raised` lifts it for focal/confirmed states. */
export default function SectionSurface({ className = '', children, as: Tag = 'div', raised = false }) {
  return (
    <Tag className={`${raised ? SURFACE_RAISED : SURFACE} ${className}`.trim()}>
      {children}
    </Tag>
  );
}
